import React from 'react';
import { connect } from 'react-redux';

import './styles.scss';
import Screw from '@scene/objects/screw/screw';

import Input from '@components/Input';
import { setPanelOptions } from '@reducers/options/panel/actions';
import { setStandOffMortarStrength, setStandOffRestraintLevel } from '@reducers/selectors/dimension/actions';
import { APP_TYPES, defaultUnits } from '@config';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { unitTransform, unitLabel } from '@services/helper.service';

const StandOffParameters = props => (

  <div className="calculation">
    <section className="list-type">
      {/* <div className="stand-off"> */}
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_STANDOFF_DISTANCE.Content}>
        <Input
          className="base-plate__input_block"
          prefix={APP_TEXTS.DIMENSION_L.Content}
          postfix={unitLabel(props.distanceUnit)}
          value={unitTransform(props.standOff).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
          disabled={!props.isStandOff}
          id="dimension"
          type="number"
          step="5"
          onUpdate={(value) => props.setStandOff(value, props.distanceUnit)}
        />
      </Tooltip>

      <Tooltip content={APP_TOOLTIPS.TOOLTIP_STANDOFF_RESTRAINT_LEVEL.Content}>
        <Input
          prefix={APP_TEXTS.RESTRAINT_LEVEL.Content}
          className="base-plate__input_block mt-2"
          value={props.restraintLevel}
          disabled={!props.isStandOff}
          id="restraint"
          type="number"
          // minValue={1}
          maxValue={2}
          onUpdate={props.setRestraintLevel}
        />
      </Tooltip>

     
        <div className={`form-check ${!props.isStandOffAndClose && "inactive"} mt-2`}>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_STANDOFF_OPTION.Content}>
            <label className="form-check-label" htmlFor="strength">
          
              <input
                checked={props.mortarStrength}
                className="form-check-input mt-0"
                disabled={!props.isStandOffAndClose}
                id="strength"
                type="checkbox"
                onChange={(e) => props.setMortarStrength(e.target.checked)}
              />
              
              {APP_TEXTS.MORTAR_STRENGTH.Content} &gt;= 30N/mm<sup>2</sup>
            </label>
          </Tooltip>
        </div>
    </section>
  </div>
);

const mapState = state => ({
  isStandOff: state.options.screw.heightType === Screw.types.height.INDENTED,
  isStandOffAndClose: state.options.screw.heightType === Screw.types.height.INDENTED && state.options.panel.isClosed,
  
  standOff: state.selectors.dimension[APP_TYPES.GENERAL_CALCULATION].standOff.standOffDimensionL,
  restraintLevel: state.selectors.dimension[APP_TYPES.GENERAL_CALCULATION].standOff.restraintLevel,
  mortarStrength: state.selectors.dimension[APP_TYPES.GENERAL_CALCULATION].standOff.mortarStrength,
  distanceUnit: state.main.units.distance
});

const mapDispatch = dispatch => ({
  setStandOff: (value, unit) => {
    dispatch(setPanelOptions({
      standOff: {
        value: !value || value < 1 ? 1 : unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE)
      }
    }));
  },

  setRestraintLevel: value => dispatch(setStandOffRestraintLevel(value)),
  setMortarStrength: value => dispatch(setStandOffMortarStrength(value))
});

export default connect(mapState, mapDispatch)(StandOffParameters);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/StandOffParameters/index.js